module.exports = __webpack_public_path__ + "img/report-5.c88538c0.png";